import React from 'react'
import Layout from '../../core/layout/layout'
import SectionTC from '../../components/section-tc/section-tc'
import { listOfferItem } from '../landing/data'
import PaymentMethods from '../landing/components/payment-methods/payment-methods'
import CustomSlider from '../../components/custom-slider/custom-slider'
import OfferItem from '../landing/components/offer-item/offer-item'
import Slider from 'react-slick'
import styled from 'styled-components'
import StepperItem from './stepper-item/stepper-item'
import { Location } from '@styled-icons/fluentui-system-regular'
import { EventSeat } from '@styled-icons/material'
import { Payment } from '@styled-icons/fluentui-system-regular'
import { ErrorWarning } from '@styled-icons/remix-fill'
import DestinyComponent from './destiny-component/destiny-component'
import SeadingComponent from './seading-component/seading-component'
import PaymentComponent from './payment-component/payment-component'
import UsersDetailComponent from './users-detail-component/users-detail-component'

const ContainerDownWave = styled.div`
    background: ${p => p.theme.palette.text.grayFullLight};
    border-radius: 0 0 50px 50px;
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;

    > svg {
        max-width: 20px;
        color: ${p => p.theme.palette.primary.main};
    }

    > p {
        font-size: 12px;
    }
`

const ContainerStepper = styled.div<{ stepperNumber: number }>`
    width: 100%;
    min-height: 100px;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    transition: .5s;

    :before{
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        width: 100%;
        height: 5px;
        background: ${p => p.theme.palette.text.grayLight};
        border-radius: 50px;
        z-index: 1;
    }

    :after{
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: ${p => p.stepperNumber === 1 ? '33%' : p.stepperNumber === 2 ? '60%' : p.stepperNumber === 3 ? '80%' : '100%'};
        height: 5px;
        background: ${p => p.theme.palette.secondary.main};
        border-radius: 50px;
        z-index: 1;
        transition: .5s;
    }
`

const SalesProcess: React.FunctionComponent = () => {
    const [stepperNumber, setStepperNumber] = React.useState(1)
    
    const sliderOfferRef = React.useRef<Slider>(null);   

    const handleNextStepper = (step: number) => setStepperNumber(step)
    const handlePay = () => console.log

  return (
    <Layout>
        <ContainerDownWave>
            <ErrorWarning />
            <p>Asegúrate de cumplir con los <b>requisitos</b> para viajar a este destino</p>
        </ContainerDownWave>
        <SectionTC>
            <ContainerStepper stepperNumber={stepperNumber}>
                <StepperItem icon={<Location />} text='Destinos' active={stepperNumber >= 1} onClick={() => setStepperNumber(1)}/>
                <StepperItem icon={<EventSeat />} text='Asientos' active={stepperNumber >= 2} onClick={() => setStepperNumber(2)}/>
                <StepperItem icon={<Payment />} text='Pagos' active={stepperNumber >= 4} onClick={() => setStepperNumber(3)}/>
            </ContainerStepper>
        </SectionTC>
        <SectionTC>
            {stepperNumber === 1 && <DestinyComponent onClick={handleNextStepper} /> }
            {stepperNumber === 2 && <SeadingComponent onClick={handleNextStepper} /> }
            {stepperNumber === 3 && <UsersDetailComponent onClick={handleNextStepper} />}
            {stepperNumber === 4 && <PaymentComponent onClick={handlePay} />}
        </SectionTC>
        {stepperNumber !== 4 &&
            <SectionTC>
              <PaymentMethods />
            </SectionTC>
        }
        {stepperNumber === 1 && (
            <CustomSlider
            sliderRef={sliderOfferRef}
            preTitle='Principales destinos'
            title='Y promociones'
            size={listOfferItem.length}
            withIconRight
            >
            {listOfferItem.map(offer => (
                <div key={offer.id}>
                <OfferItem
                    tour={offer.tour}
                    price={offer.price}
                    title={offer.title}
                    subTitle={offer.subTitle}
                    image={offer.image}
                    />
                </div>
            ))}
            </CustomSlider>
        )}
    </Layout>
  )
}

export default SalesProcess